import { Account, SignableType } from '@mls-wallet/shared-types';
import { AddressDisplay } from '@/components/shared/address-display';

interface OriginDisplayProps {
  account: Account;
  variant?: 'cell' | 'detail';
  showCopy?: boolean;
  showBlockExplorerLink?: boolean;
  className?: string;
  centerWhenNoLabel?: boolean;
}

export function OriginDisplay({
  account,
  variant = 'cell',
  showCopy,
  showBlockExplorerLink,
  className = '',
  centerWhenNoLabel,
}: OriginDisplayProps) {
  return (
    <AddressDisplay
      address={account.address}
      name={account.name}
      networkId={account.networks[0]}
      showNetwork={Boolean(account.networks[0])}
      centerWhenNoLabel={centerWhenNoLabel}
      showCopy={showCopy ?? variant === 'detail'}
      showBlockExplorerLink={showBlockExplorerLink ?? variant === 'detail'}
      className={className}
    />
  );
}

interface DestinationDisplayProps {
  type: SignableType;
  destination?: string;
  destinationName?: string | null | undefined;
  contractAddress?: string;
  contractAddressName?: string | null | undefined;
  networkId?: number | undefined;
  variant?: 'cell' | 'detail';
  showCopy?: boolean;
  showBlockExplorerLink?: boolean;
  className?: string;
  centerWhenNoLabel?: boolean;
}

export function DestinationDisplay({
  type,
  destination,
  destinationName,
  contractAddress,
  contractAddressName,
  networkId,
  className = '',
  variant = 'cell',
  showCopy,
  showBlockExplorerLink,
  centerWhenNoLabel,
}: DestinationDisplayProps) {
  const address =
    type === SignableType.TokenTransfer ? destination : contractAddress;
  const addressName =
    type === SignableType.TokenTransfer ? destinationName : contractAddressName;

  if (!address) {
    return null;
  }

  return (
    <AddressDisplay
      address={address}
      name={addressName}
      networkId={networkId}
      showNetwork={Boolean(networkId)}
      centerWhenNoLabel={centerWhenNoLabel}
      showCopy={showCopy ?? variant === 'detail'}
      showBlockExplorerLink={showBlockExplorerLink ?? variant === 'detail'}
      className={className}
    />
  );
}
